export class UserAuth {
  id?: number | null;
  email?: string | null;
  username?: string | null;
  vendorId?: number | null;

  constructor(dto?: Partial<UserAuth>) {
    Object.assign(this, dto);
  }
}
